import styled from "styled-components";

export const BoxTabel = styled.div`
	.MuiAppBar-colorPrimary {
		margin-bottom: 15px;
		color: #000;
		background-color: transparent;
		box-shadow: none;
	}
	.MuiTabs-indicator {
		background-color: ${({ theme }) => theme.pantone2726C};
	}
	.MuiTab-root,
	.MuiTabs-scroller.MuiTabs-fixed,
	.MuiTabs-root {
		min-height: auto;
		text-transform: none;
	}
	.MuiTab-root {
		padding: 8px 12px;
		color: rgba(0, 0, 0, 0.7) !important;
	}

	.Mui-selected {
		color: #000 !important;
	}

	@media (min-width: 600px) {
		.MuiTab-root {
			min-width: 110px;
		}
	}
`;
